import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue";
import _imports_0 from '../assets/img/video.svg';
import _imports_1 from '../assets/img/audio-2.svg';
import _imports_2 from '../assets/img/text-2.svg';
import _imports_3 from '../assets/img/excel-2.svg';
import _imports_4 from '../assets/img/pdf-2.svg';
const _hoisted_1 = ["src"];
const _hoisted_2 = ["src"];
const _hoisted_3 = ["src"];
const _hoisted_4 = {
    key: 3,
    src: _imports_0,
    class: "w-[50px] h-[50px]"
};
const _hoisted_5 = {
    key: 4,
    src: _imports_1,
    class: "w-[50px] h-[50px]"
};
const _hoisted_6 = {
    key: 5,
    src: _imports_2,
    class: "w-[50px] h-[50px]"
};
const _hoisted_7 = {
    key: 6,
    src: _imports_3,
    class: "w-[50px] h-[50px]"
};
const _hoisted_8 = {
    key: 7,
    src: _imports_4,
    class: "w-[50px] h-[50px]"
};
import { computed } from 'vue';
import { MIME_TYPES } from '../util/const_helper';
export default /*#__PURE__*/ _defineComponent({
    __name: 'TableImage',
    props: {
        file: {},
        type: {}
    },
    setup(__props) {
        const props = __props;
        function generateCDNLink(url) {
            return `https://images-staging.leadconnectorhq.com/image/f_webp/q_80/r_50/u_${url}`;
        }
        const fileType = computed(() => {
            for (const [type, mimeTypes] of Object.entries(MIME_TYPES)) {
                if (Array.isArray(mimeTypes)) {
                    if (mimeTypes.includes(props.file.contentType)) {
                        return type;
                    }
                }
                else {
                    for (const [subType, subMimeTypes] of Object.entries(mimeTypes)) {
                        if (subMimeTypes.includes(props.file.contentType)) {
                            return subType;
                        }
                    }
                }
            }
            return 'other';
        });
        function getImageLink(file) {
            if (props.type === 'file' || props.type === 'static') {
                return generateCDNLink(file.url);
            }
            else if (props.type === 'pixabay') {
                return generateCDNLink(file.previewURL);
            }
            else if (props.type === 'unsplash') {
                return generateCDNLink(file.urls.regular);
            }
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (['pixabay', 'unsplash'].includes(_ctx.type))
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "w-[50px] h-[50px]",
                        src: getImageLink(_ctx.file),
                        alt: "file"
                    }, null, 8, _hoisted_1))
                    : _createCommentVNode("", true),
                (['file'].includes(_ctx.type) && fileType.value === 'image')
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        class: "w-[50px] h-[50px]",
                        src: getImageLink(_ctx.file),
                        alt: "file"
                    }, null, 8, _hoisted_2))
                    : _createCommentVNode("", true),
                (['static'].includes(_ctx.type))
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 2,
                        class: "w-[50px] h-[50px]",
                        src: getImageLink(_ctx.file),
                        alt: "file"
                    }, null, 8, _hoisted_3))
                    : _createCommentVNode("", true),
                (fileType.value === 'video')
                    ? (_openBlock(), _createElementBlock("img", _hoisted_4))
                    : _createCommentVNode("", true),
                (fileType.value === 'audio')
                    ? (_openBlock(), _createElementBlock("img", _hoisted_5))
                    : _createCommentVNode("", true),
                (fileType.value === 'text')
                    ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                    : _createCommentVNode("", true),
                (fileType.value === 'excel')
                    ? (_openBlock(), _createElementBlock("img", _hoisted_7))
                    : _createCommentVNode("", true),
                (fileType.value === 'pdf')
                    ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
